import './styles.css';
import { App } from './app-simple';

// Create app HTML structure - matching voice.conventic.com layout
document.getElementById('app')!.innerHTML = `
  <!-- Page-level logo in top-left -->
  <div class="page-logo">
    <img src="https://www.conventic.com/images/logo-ai-excellence.png" alt="conventic" />
  </div>

  <!-- Main content area with chat and bot -->
  <div class="main-layout">
    <!-- Chat wrapper - contains chat and bot -->
    <div class="chat-wrapper">
      <!-- Bot mascot overlapping chat from top-right -->
      <div class="bot-wrapper">
        <img 
          src="https://www.conventic.com/images/bot.png" 
          alt="conventic Bot" 
          class="bot-mascot" 
          id="bot-img"
        />
        <spline-viewer 
          url="/spline/scene.splinecode"
          class="bot-spline"
          id="bot-spline"
          loading-anim-type="none"
        ></spline-viewer>
      </div>

      <!-- Chat container -->
      <div class="chat-container">
        <div class="messages" id="messages"></div>
        <div class="input-container">
          <div class="input-wrapper">
            <input
              type="text"
              id="input"
              class="input"
              placeholder="Frage tippen..."
              autocomplete="off"
            />
            <button id="send-button" class="send-button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer links -->
  <footer class="page-footer">
    <a href="https://www.conventic.com/impressum.html" target="_blank" rel="noreferrer">Impressum</a>
    <span>•</span>
    <a href="https://www.conventic.com/datenschutz.html" target="_blank" rel="noreferrer">Datenschutz</a>
  </footer>
`;

// Hide PNG when Spline loads and hide watermark
const splineViewer = document.getElementById('bot-spline') as any;
const botImg = document.getElementById('bot-img');
const isMobile = window.matchMedia('(max-width: 768px)').matches;
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (splineViewer && botImg && !isMobile && !prefersReducedMotion) {
  // Hide the Spline watermark by injecting CSS into shadow DOM
  const hideSplineWatermark = (shadowRoot: ShadowRoot) => {
    const style = document.createElement('style');
    style.textContent = `
      #logo, a[href*="spline.design"] {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
    `;
    shadowRoot.appendChild(style);
    console.log('[Spline] Watermark hidden via injected CSS');
  };

  // Spline viewer fires 'spline-ready' event when fully loaded
  // Also listen to 'load' as fallback
  const hideBot = () => {
    console.log('[Spline] Scene loaded, hiding PNG fallback');
    botImg.classList.add('hidden');
  };

  // Multiple event listeners as Spline version may vary
  splineViewer.addEventListener('load', hideBot);
  splineViewer.addEventListener('spline-ready', hideBot);
  splineViewer.addEventListener('load-complete', hideBot);

  // Check periodically for shadow DOM to hide watermark and detect load
  const checkSplineLoaded = setInterval(() => {
    const shadowRoot = splineViewer.shadowRoot;
    if (shadowRoot) {
      // Hide watermark first
      if (!shadowRoot.querySelector('style[data-cvt-hide]')) {
        const style = document.createElement('style');
        style.setAttribute('data-cvt-hide', 'true');
        style.textContent = `
          #logo, a[href*="spline.design"] {
            display: none !important;
            opacity: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
            width: 0 !important;
            height: 0 !important;
            overflow: hidden !important;
          }
        `;
        shadowRoot.appendChild(style);
        console.log('[Spline] Watermark CSS injected');
      }

      // Check for canvas to know it's loaded
      const canvas = shadowRoot.querySelector('canvas');
      if (canvas) {
        console.log('[Spline] Canvas detected in shadow DOM, hiding PNG');
        hideBot();
        clearInterval(checkSplineLoaded);
      }
    }
  }, 100);

  // Clear interval after 10 seconds to avoid memory leak
  setTimeout(() => clearInterval(checkSplineLoaded), 10000);
} else if (splineViewer) {
  // Keep the PNG fallback on mobile or when reduced motion is preferred
  splineViewer.remove();
}

// Initialize app
const app = new App();
app.init();
